const isDebugEnabled = () => process.env.REACT_APP_DEBUG === 'true'

const debugLog = (...args) => {
  if (isDebugEnabled()) console.log(...args)
}

if (!isDebugEnabled()) {
  // eslint-disable-next-line no-console
  console.log = () => {}
}

export { isDebugEnabled, debugLog }
